import React from "react";
import { useParams } from "react-router-dom";
import Utils from '../../utilities';
import kpiService from "../../services/kpiService";
import { useKPI } from "../../hooks";

const KPIContext = React.createContext();

export const KPIProvider = ({ children }) => {
    const { treeId } = useParams();
    const kpiTreeId = treeId;
  
    // const [editMode, setEditMode] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [isError, setError] = React.useState('');
    const [sampleKPITree, setSampleKPITree] = React.useState([]);
    const [treeData, setTreeData] = React.useState([]);
    const [kpiData, setKpiData] = React.useState([]);
    const [treeFilter, setTreeFilter] = React.useState([]);
    const [treeFilterResponse, setTreeFilterResponse] = React.useState(null);
    const [toggleTreelist, setToggleTreelist] = React.useState(false);
    const { isJsonString } = Utils;

    const getFilteredAnalysis = (initialLoad, treeFilterArg) => {
      setLoading(true)
        let selectedFilter = {};
        let allFilters = [];
    
        if(initialLoad && treeFilterArg === ""){
          selectedFilter = "";
        }else{
          allFilters = initialLoad ? treeFilterArg : treeFilter;
          allFilters.forEach((filter) => selectedFilter[filter.name] = filter.selected);
          setTreeFilter(allFilters);
        }
    
        const postData = {
          kpiTreeId: kpiTreeId,
          filter: JSON.stringify(selectedFilter),
        };

        kpiService
          .getFilteredAnalysis(postData)
          .then(({ data }) => {
            if(data.code === 200){
              setSampleKPITree(data.response.kpiTree);
              setTreeData(
                {
                  analysisId: kpiTreeId,
                  analysisName: data.response.kpiTree[0].treeName,
                  enableCohortOps: data.response.enableCohortOps,
                  analysisGoal: data.response.kpiTreeGoal,
                  colorThreshold: data.response.colorThreshold,
                  selectedFilter: selectedFilter,
                  polarity: JSON.parse(data.response.polarity),
                  unit: JSON.parse(data.response.unit),
                  drivers: isJsonString(data.response.populateDrivers),
                  kpiTemplateName: data.response.templateName,
                  groupName: data.response?.groupName ?? "",
                  chosenFilter: isJsonString(data.response.chosenFilter),
                  treeDate: { createdDate: data.response.createdDate, modifiedDate: data.response.modifiedDate, refreshDate: data.response?.refreshDate, publishedDate: data.response?.publishedDate }
                }
              )
            }else{
              setError(data?.message)
              console.log(data?.message)
            }
          })
          .catch(error => setError(error?.message))
          .finally(() => setLoading(false))
    };

    const getKPITreeData = () => {
      setLoading(true)
        if (kpiTreeId !== "") {
            kpiService
            .getTreeNodes(kpiTreeId)
            .then(({ data }) => {
                if (data.code === 200) {
                  let nodeId = JSON.parse(data.response.rawTree)[0].nodeId;
                  
                  setSampleKPITree([{...JSON.parse(data.response.sampleTree)[0], nodeId}]);
                  setKpiData([...JSON.parse(data.response.rawTree)]);
                  setTreeData(
                      {
                        analysisId: data.response.kpiTreeId,
                        analysisName: data.response.kpiTreeName,
                        analysisGoal: data.response.kpiTreeGoal,
                        colorThreshold: data.response.colorThreshold,
                        drivers: isJsonString(data.response.populateDrivers),
                        kpiTemplateName: data.response.templateName,
                        groupName: data.response?.groupName ?? "",
                        kpiTreeParameter: isJsonString(data.response.kpiTreeParameter),
                        cohorts: isJsonString(data.response.cohortName),
                        kpiTreeDomain: data.response.kpiTreeDomain,
                        kpiTreeStatus: data.response.kpiTreeStatus,
                        enableCohortOps: data.response.enableCohortOps,
                        treeFilter: null,
                        polarity: null,
                        unit: null,
                        //treeDate: { createdDate: new Date(data.response.createdDate).toLocaleDateString(), modifiedDate: new Date(data.response.modifiedDate).toLocaleDateString() },
                        treeDate: { createdDate: data.response.createdDate, modifiedDate: data.response.modifiedDate, refreshDate: data.response?.refreshDate, publishedDate: data.response?.publishedDate },
                        connectionName: data.response.connectionName,
                        chosenFilter:isJsonString(data.response.chosenFilter),
                        globalPrimaryQuery: data.response.globalPrimaryQuery,
                      }
                  )
                }else{
                  setError(data?.message)
                  console.error(data?.message);
                }
            })
            .catch(error => setError(error?.message))
            .finally(() => setLoading(false))
        }
    };

    const getFilterList = (data) => {
        let arrTreeFilter = [];
        if (data !== "") {
          let ar = [];
          data.forEach((item) => {
            Object.entries(item).forEach((el) => {
              ar = [...ar, el[0]];
            });
          });
    
          let obj = {};
          [...new Set(ar)].forEach((rec) => {
            data.forEach((item) => {
              if (item.hasOwnProperty(rec)) {
                if (obj[rec]) {
                  obj = { ...obj, [rec]: [...obj[rec], item[rec]] };
                } else {
                  obj = { ...obj, [rec]: [item[rec]] };
                }
              }
            });
          });
    
          const objectArray = Object.entries(obj);
          objectArray.forEach(([key, value]) => {
            arrTreeFilter.push({ name: key, value: value, selected: value[0] });
          });
        } else {
          arrTreeFilter = "";
        }
        setTreeFilter(arrTreeFilter);
        getFilteredAnalysis(true, arrTreeFilter);
    };

    const getKPITreeFilter = () => {
      setLoading(true);
        if (kpiTreeId !== "") {
          kpiService
            .getKPITreeFilter(kpiTreeId)
            .then(({ data }) => {
              const parsedFilters = data.response.map((item) => JSON.parse(item));
              setTreeFilterResponse(parsedFilters);
              if(parsedFilters.length){
                getFilterList([...parsedFilters]);
              }
            })
            .catch((error) => console.error(error.message))
            .finally(() => setLoading(false));
        }
    };


    return (
      <KPIContext.Provider value={{ isLoading, setLoading, isError, kpiTreeId, sampleKPITree, treeData, kpiData, treeFilter, treeFilterResponse, setSampleKPITree, setTreeData, setKpiData, getFilteredAnalysis, setTreeFilterResponse, getKPITreeData, getKPITreeFilter, toggleTreelist, setToggleTreelist }}>
        {children}
      </KPIContext.Provider>
    );
}

export { KPIContext };
